/*
  useTheme.js
*/

// Npm.
import { useContext } from 'react';

// Contexts.
import ThemeContext from '../contexts/ThemeContext';

/**
 * Hook to return the currently active theme.
 */
export default function useTheme() {

  return useContext(ThemeContext);

}
